<script>
  import BadgeDetails from "./BadgeDetails.svelte";

  export let badge;
  export let active = true;
  export let badgeSize = "default";

  $: bWidth = (badgeSize === "medium" ? 66 : 37) + "px";
  $: bHeight = (badgeSize === "medium" ? 73.84 : 41.66) + "px";
</script>

<div
  class="relative bg-center bg-no-repeat bg-contain nx-badge"
  style="--b-width: {bWidth}; --b-height: {bHeight}; background-image: url({active ? badge.urls.image : badge.urls.grayImage})">
  <div class="absolute z-10 invisible transition-all opacity-0 badge-tip">
    <div class="absolute z-20 bg-white border-t border-l chevron" />
    <div class="absolute p-4 bg-white border rounded shadow details">
      <BadgeDetails {badge} />
    </div>
  </div>
</div>

<style>
  .nx-badge {
    width: var(--b-width, 78px);
    height: var(--b-height, 87px);
  }
  .nx-badge:hover .badge-tip {
    transition-delay: 300ms;
    visibility: visible;
    opacity: 1;
  }
  .badge-tip {
    width: 400px;
    top: 80%;
    left: calc((var(--b-width) - 400px) / 2);
    /* -161px; (width of .badge-tip/2) - (width of .nx-badge/2) */
  }
  .chevron {
    width: 20px;
    height: 20px;
    transform: rotate(45deg);
    left: calc(50% - 10px);
  }
  .details {
    top: 10px;
  }
</style>
